<template>
    <div class="home" :data-theme="uiTheme" :style="themeStyle">
        <el-container style="height: 100%;">
            <el-header style="box-shadow: 0 2px 10px 0 rgba(0 0 0 / 10%)">
                <div class="header">
                    <div class="logoBox">
                        <img class="logo-img" :src="logoSrc" alt="logo" />
                    </div>
                    <TopMenu
                        :menuData="menuData"
                        :actId="sMenuAct.toString()"
                        :theme="uiTheme"
                        :rightGap="menuRightGap"
                        @selectMenu="selectMenu"
                    ></TopMenu>
                    <div
                        class="headRightBox"
                        :class="{ 'headRightBox--single': headActionCount === 1 }"
                    >
                        <div class="moniterBox" v-if="has_moniter" @click="toMoniter">
                            <img class="header-action-img header-action-img--screen" :src="screenIconSrc" alt="大屏" />
                            <div class="txt">大屏</div>
                        </div>
                        <div class="moniterBox" v-if="user_type>1" @click="toMap">
                            <img class="header-action-img" :src="mapIconSrc" alt="地图" />
                            <div class="txt">地图</div>
                        </div>
                    </div>
                    <el-dropdown class="dropdownBox">
                        <div class="avatarBox">
                            <el-avatar>{{avatar}}</el-avatar>
                            <i class="el-icon-caret-bottom header-caret-icon"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="toggleTheme">{{ themeToggleLabel }}</el-dropdown-item>
                            <el-dropdown-item @click.native="changePass">修改密码</el-dropdown-item>
                            <el-dropdown-item divided @click.native="logOut">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <NavTags :tags="navTags" :actId="sMenuAct" :showHome="showHomeTag" @tagClick="tagClick" @tagClose="tagClose"></NavTags>
            <el-container style="width: 100%">
                <el-main class="mainBox">
                    <keep-alive :include="cacheList">
                        <router-view />
                    </keep-alive>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import config from "@/config/index"
import TopMenu from './topmenu'
import NavTags from './navtags'
import {
    getStoredTheme,
    setStoredTheme,
    getThemeAssets,
    getNextTheme,
    getThemeLabel,
} from '@/libs/uiTheme'
import {loginOut, continueSession} from '@/api/login'
import {getUserInfo, getMenuData} from '@/api/common'

export default {
    components: {
        TopMenu, NavTags
    },
    data(){
        return {
            user: {},
            user_type: 0,
            menuData: [],
            fMenuAct: 0,
            sMenuAct: 0,
            fMenuName: '',
            sMenuName: '',
            navIds: [],//防止重复
            navTags: [],
            cacheList: [],//缓存列表,
            isCollapse: false,
            title: config.title,
            has_moniter: false,
            showHomeTag: localStorage.getItem("hideHomeTag") != '1',
            uiTheme: getStoredTheme(),
        }
    },
    computed: {
        avatar(){
            if(this.user.realname != undefined){
                return this.user.realname.substring(0,1)
            }
        },
        logoSrc() {
            return getThemeAssets(this.uiTheme).logo
        },
        screenIconSrc() {
            return getThemeAssets(this.uiTheme).screen
        },
        mapIconSrc() {
            return getThemeAssets(this.uiTheme).map
        },
        headActionCount() {
            let count = 0
            if (this.has_moniter) count += 1
            if (this.user_type > 1) count += 1
            return count
        },
        menuRightGap() {
            return 8
        },
        themeStyle() {
            const assets = getThemeAssets(this.uiTheme)
            return {
                '--theme-header-bg': `url('${assets.menu}')`,
                '--theme-right': `url('${assets.right}')`,
                '--theme-menu-active-bg': `url('${assets.activeBg}')`,
            }
        },
        themeToggleLabel() {
            const next = getNextTheme(this.uiTheme)
            return '切换为' + getThemeLabel(next)
        },
    },
    mounted(){
        this.uiTheme = getStoredTheme()
        this.syncUiThemeToBody()
        this.getUser()
        this.getCacheMenu()
        //this.continueSession();
    },
    beforeDestroy() {
        document.body.removeAttribute('data-ui-theme')
    },
    methods: {
        syncUiThemeToBody() {
            document.body.setAttribute('data-ui-theme', this.uiTheme)
        },
        getUser(){
            let u_token = sessionStorage.getItem("U_TOKEN")
            if(u_token == null){
                u_token = ""
            }
            getUserInfo(u_token).then(res=>{
                if(res.code == 999){
                    sessionStorage.removeItem("U_TOKEN")
                    this.$router.push({name: 'Login'})
                }else{
                    this.user = res.data
                    this.user_type = res.data.user_type
                    this.getMenuData()
                }
            })
        },
        getMenuData(){
            getMenuData().then(res=>{
                if(res.code ==1){
                    this.menuData = res.data.menuData
                    this.has_moniter = res.data.has_moniter
                    let home_page = localStorage.getItem("home_page")
                    console.log("home_page:"+home_page)
                    if(home_page == '2' && this.menuData.length > 0){
                        //隐藏首页标签（持久化，刷新后保持隐藏）
                        this.showHomeTag = false
                        localStorage.setItem("hideHomeTag", '1')
                        // 登录后自动选中"灌浆记录报告 > 作业报告列表"并添加标签
                        let targetFMenu = null
                        let targetSMenu = null
                        for(let i = 0; i < this.menuData.length; i++){
                            if(this.menuData[i].fMenu.name == '灌浆记录报告'){
                                targetFMenu = this.menuData[i].fMenu
                                let sList = this.menuData[i].sMenuList
                                for(let j = 0; j < sList.length; j++){
                                    if(sList[j].name == '作业报告列表'){
                                        targetSMenu = sList[j]
                                        break
                                    }
                                }
                                break
                            }
                        }
                        if(targetFMenu && targetSMenu){
                            let params = {
                                fMenuIndex: targetFMenu.id,
                                sMenuIndex: targetSMenu.id,
                                menu: 0
                            }
                            this.selectMenu(params)
                            this.$router.push({path: targetSMenu.linkurl})
                        }
                        localStorage.removeItem("home_page")
                    }else if(home_page == '1'){
                        //home_page==1时恢复"首页"标签显示，并清除持久化标记
                        this.showHomeTag = true
                        localStorage.removeItem("hideHomeTag")
                        localStorage.removeItem("home_page")
                    }
                }
            })
        },
        selectMenu(params){
            this.fMenuAct = Number(params.fMenuIndex)
            this.sMenuAct = Number(params.sMenuIndex)
            if(this.fMenuAct === 9998){
                //修改密码
                this.fMenuName = '个人设置'
                this.sMenuName = '修改密码'
                let menu = {
                    'id': 9998,
                    'name': '修改密码',
                    'linkurl': '/user/changePass',
                    'pid': 9998,
                    'mdesc': 'changePassword'
                }
                this.addNavTags(menu)
            }if(this.fMenuAct === 0){
                this.fMenuName = ''
                this.sMenuName = ''
            }else{
                for (const index in this.menuData) {
                    if(this.fMenuAct == this.menuData[index].fMenu.id){
                        this.fMenuName = this.menuData[index].fMenu.name
                        const sMenuList = this.menuData[index].sMenuList
                        for (const sIndex in sMenuList) {
                            if(sMenuList[sIndex].id == this.sMenuAct){
                                this.sMenuName = sMenuList[sIndex].name
                                this.addNavTags(sMenuList[sIndex])
                                break
                            }
                        }
                        break
                    }
                }
            }
        },
        addNavTags(menu){
            if(this.navIds.indexOf(menu.id.toString()) >=0){
                return
            }
            this.navIds.push(menu.id.toString())
            let tagItem = {
                'id': menu.id,
                'name': menu.name,
                'linkurl': menu.linkurl,
                'pid': menu.pid,
                'mdesc': menu.mdesc
            }
            this.navTags.push(tagItem)
            this.setCacheList()
        },
        tagClick(params){
            this.sMenuAct = params.tag.id
            let params1 = {
                'fMenuIndex': params.tag.pid,
                'sMenuIndex': params.tag.id,
                'menu': 0
            }
            this.selectMenu(params1)
            this.$router.push({path: params.tag.linkurl})
        },
        tagClose(params){
            let index = params.index
            let tag = this.navTags[index]
            console.log(tag.id)
            if(tag.id == '1500'){
                this.$globalData.timmer1 && clearTimeout(this.$globalData.timmer1)
            }else if(tag.id == '4300'){
                this.$globalData.timmer3 && clearTimeout(this.$globalData.timmer3)
                this.$globalData.timmer4 && clearTimeout(this.$globalData.timmer4)
                this.$globalData.timmer5 && clearTimeout(this.$globalData.timmer5)
            }
            if(this.navTags.length ==1){
                this.fMenuAct = 0
                this.sMenuAct = 0
                this.$router.push({path:'/home'})
                this.fMenuName = ''
                this.sMenuName = ''
                localStorage.removeItem("actMenu")
            }else if(this.sMenuAct == tag.id){
                let o_index = index -1
                if(o_index < 0){
                    o_index = 1
                }
                tag = this.navTags[o_index]
                let params1 = {
                    'fMenuIndex': tag.pid,
                    'sMenuIndex': tag.id,
                    'menu': 0
                }
                this.selectMenu(params1)
                this.$router.push({path: tag.linkurl})
            }
            this.navIds.splice(index, 1)
            this.navTags.splice(index, 1)
            this.setCacheList()
        },
        setCacheList(){
            this.cacheList = []
            let pageList = this.navTags
            if(pageList.length ==0){
                this.cacheList = []
            }else{
                for (const key in pageList) {
                    this.cacheList.push(pageList[key].mdesc)
                }
            }
            this.setCacheMenu()
        },
        setCacheMenu(){
            localStorage.setItem("navTags", JSON.stringify(this.navTags))
            localStorage.setItem("navIds", JSON.stringify(this.navIds))
        },
        getCacheMenu(){
            let navTags_str = localStorage.getItem("navTags")
            if(this.$isNotNull(navTags_str)){
                this.navTags = JSON.parse(navTags_str)
            }
            let navIds_str = localStorage.getItem("navIds")
            if(this.$isNotNull(navIds_str)){
                this.navIds = JSON.parse(navIds_str)
            }
            // 恢复选中状态：根据当前路由匹配缓存标签
            let currentPath = this.$route.path
            let matched = false
            if(this.navTags.length > 0){
                for(let i = 0; i < this.navTags.length; i++){
                    if(this.navTags[i].linkurl == currentPath){
                        this.sMenuAct = this.navTags[i].id
                        this.fMenuAct = this.navTags[i].pid
                        matched = true
                        break
                    }
                }
            }
            if(!matched){
                this.sMenuAct = 0
                this.fMenuAct = 0
            }
            this.setCacheList()
        },
        toggleTheme() {
            const next = getNextTheme(this.uiTheme)
            this.uiTheme = next
            setStoredTheme(next)
            this.syncUiThemeToBody()
        },
        changePass(){
            let params = {
                'fMenuIndex': 9998,
                'sMenuIndex': 9998,
                'menu': 0
            }
            this.selectMenu(params)
            this.$router.push({path:'/user/changePass'})
        },
        logOut(){
            loginOut().then(res=>{
                sessionStorage.removeItem("U_TOKEN")
                localStorage.removeItem("actMenu")
                localStorage.removeItem("hideHomeTag")
                this.$globalData.timmer1 && clearTimeout(this.$globalData.timmer1)
                this.$globalData.timmer2 && clearTimeout(this.$globalData.timmer2)
                this.$globalData.timmer3 && clearTimeout(this.$globalData.timmer3)
                this.$globalData.timmer4 && clearTimeout(this.$globalData.timmer4)
                this.$globalData.timmer5 && clearTimeout(this.$globalData.timmer5)
                this.$router.push({name:'Login'})
            })
        },
        goHome(){
            let params = {
                'fMenuIndex': 0,
                'sMenuIndex': 0,
                'menu': 0
            }
            this.selectMenu(params)
            this.$router.push({path:'/home'})
        },
        collapse(){//收起左侧菜单
            if(this.isCollapse){
                this.isCollapse = false
            }else{
                this.isCollapse = true
            }
        },
        continueSession(){
            setTimeout(() => {
                this.continueSession1()
            }, 60*1000);
        },
        continueSession1(){
            continueSession().then(res=>{
                this.continueSession()
            })
        },
        toMoniter(){
            var route = this.$router.resolve({
                path: '/moniter',
            })
            window.open(route.href, '_blank')
        },
        toMap(){
            this.$router.push({path:'/map'})
        }
    },
};
</script>
